"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.REDIRECTION_TYPE = exports.MOVE_BUTTON_THEME_OVERRIDES = exports.LINK_TARGET = exports.LINK_HOVER_BEHAVIOR = exports.BUTTON_TYPE = void 0;
var LINK_TARGET = {
  tab: {
    type: 'tab',
    code: '_blank'
  },
  self: {
    type: 'self',
    code: '_self'
  },
  parent: {
    type: 'parent',
    code: '_parent'
  }
};
exports.LINK_TARGET = LINK_TARGET;
var LINK_HOVER_BEHAVIOR = {
  hover: {
    code: 'underlined'
  }
};
exports.LINK_HOVER_BEHAVIOR = LINK_HOVER_BEHAVIOR;
var REDIRECTION_TYPE = {
  normal: 'normal',
  secured: 'secured'
};
exports.REDIRECTION_TYPE = REDIRECTION_TYPE;
var BUTTON_TYPE = {
  button: 'button',
  link: 'link'
}; // Workaround for theming MOVE buttons
// Supports only CLASSIC and MOVE themes

exports.BUTTON_TYPE = BUTTON_TYPE;
var MOVE_BUTTON_THEME_OVERRIDES = {
  AIRASIA_CLASSIC: {
    primary: {
      true: {
        backgroundColor: 'primary',
        color: 'default'
      },
      false: {
        backgroundColor: 'greyLighter',
        border: 'greyMediumLight',
        color: 'greyMediumLight'
      }
    },
    secondary: {
      true: {
        backgroundColor: 'default',
        border: 'primary',
        color: 'primary'
      },
      false: {}
    },
    textLink: {
      true: {
        color: 'secondary'
      },
      false: {
        color: 'greyLight'
      }
    },
    spinner: {
      color: 'primary'
    }
  },
  AIRASIA_MOVE: {
    primary: {
      true: {
        backgroundColor: 'primary',
        border: 'secondary',
        color: 'secondary',
        hoverBackgroundColor: 'primaryDark',
        hoverColor: 'secondary'
      },
      false: {
        backgroundColor: 'greyLighter',
        border: 'greyMediumLight',
        color: 'greyMediumLight'
      }
    },
    secondary: {
      true: {
        backgroundColor: 'default',
        border: 'secondary',
        color: 'secondary',
        hoverBackgroundColor: 'secondaryLight',
        hoverColor: 'secondary'
      },
      false: {
        backgroundColor: 'default',
        border: 'greyLight',
        color: 'greyLight'
      }
    },
    textLink: {
      true: {
        color: 'tertiaryRed'
      },
      false: {
        color: 'greyLight'
      }
    },
    spinner: {
      color: 'secondary'
    }
  }
};
exports.MOVE_BUTTON_THEME_OVERRIDES = MOVE_BUTTON_THEME_OVERRIDES;